import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type ThemeMode = 'light' | 'dark' | 'system'

interface ThemeState {
  themeMode: ThemeMode
  isDarkMode: boolean
  setThemeMode: (mode: ThemeMode) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      themeMode: 'system',
      isDarkMode: false,

      setThemeMode: (mode: ThemeMode) => {
        set({ themeMode: mode })
        
        // Update isDarkMode based on the new mode
        const updateTheme = () => {
          let isDark = false
          
          if (mode === 'dark') {
            isDark = true
          } else if (mode === 'light') {
            isDark = false
          } else if (mode === 'system') {
            isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
          }
          
          set({ isDarkMode: isDark })
          
          // Update document class
          if (isDark) {
            document.documentElement.classList.add('dark')
          } else {
            document.documentElement.classList.remove('dark')
          }
        }
        
        updateTheme()
      },
    }),
    {
      name: 'theme-storage',
    }
  )
)

// Initialize theme on load
if (typeof window !== 'undefined') {
  const { themeMode, setThemeMode } = useThemeStore.getState()
  
  // Set initial theme
  setThemeMode(themeMode)
  
  // Listen for system theme changes
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const { themeMode, setThemeMode } = useThemeStore.getState()
    if (themeMode === 'system') {
      setThemeMode('system') // This will trigger the update
    }
  })
}